<template>
    <v-container class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="mb-10">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Notas</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-btn color="success" :disabled="disabled" @click="nuevo()">
                            <v-icon>
                                mdi-plus-box-outline

                            </v-icon>
                        </v-btn>
                        <br />
                        <br />
                        <masonry-infinite-grid class="container" v-bind:gap="15">
                            <v-card elevation="10" class="item-style" v-for="(item, index) in items" :key="index"
                                :class="validaestilo(index)" :data-grid-groupkey="item.groupKey">
                                <div style="width: 100%">
                                    <v-card-title class="justify-center d-flex flex-nowrap">
                                        <p class="text-h6 font-weight-bold"><span class="primary--text mr-2">{{
                                            item.nottitulo }}</span></p>
                                        <v-spacer></v-spacer>
                                        <v-menu>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="greyTint">mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="editar(item)" :disabled="disabled">
                                                    <v-list-item-title>Editar</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="eliminar(item.notclave)">
                                                    <v-list-item-title>Eliminar</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-card-title>
                                    <v-divider class="primary"></v-divider>
                                    <v-card-text>
                                        <v-row no-gutters class="pb-0">
                                            <v-col cols="12" class="my-auto">
                                                <span class="font-weight-medium greyBold--text"
                                                    style="font-size: 20px;">{{ item.notdescripcion }}</span>
                                            </v-col>

                                        </v-row>

                                    </v-card-text>
                                    <template v-if="item.nottipo == true">
                                        <v-card-actions class="ma-2">
                                            <v-row no-gutters class="pb-0" justify="space-between">
                                                <v-col cols="auto" class="d-flex flex-column align-center">
                                                    <p class="greyTint--text my-0" style="font-size: 17px">Fecha de
                                                        recordatorio</p>
                                                    <div class="">
                                                        <span class="greyBold--text font-weight-regular"
                                                            style="font-size: 15px">{{ item.fecha }} {{ item.hora
                                                            }}</span>
                                                        <v-icon size="30" color="success"
                                                            class="mt-n1">mdi-circle-small</v-icon>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-card-actions>
                                    </template>
                                </div>
                            </v-card>
                        </masonry-infinite-grid>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog transition="dialog-bottom-transition" persistent v-model="dialog" max-width="600">
            <template>
                <v-card>
                    <v-toolbar color="primary" dark>{{ titulo }}</v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-form ref="form" v-model="valid">
                                    <label class="typo__label" style="text-align: center;">Titulo:</label>
                                    <v-text-field outlined dense :rules="[rules.required, rules.counter, rules.text]"
                                        required v-on:blur="nottitulo = nottitulo != null ? nottitulo.trim() : null"
                                        v-model="nottitulo">
                                    </v-text-field>
                                    <label class="typo__label" style="text-align: center;">Descripción:</label>
                                    <v-textarea outlined dense :counter="250" :rules="rulestextarea" required
                                        v-on:blur="notdescripcion = notdescripcion != null ? notdescripcion.trim() : null"
                                        v-model="notdescripcion">
                                    </v-textarea>
                                    <v-checkbox v-model="nottipo" label="Agregar Recordatorio">
                                    </v-checkbox>
                                    <template v-if="nottipo == true">
                                        <label class="typo__label" style="text-align: center;">Fecha
                                            recordatorio:</label>
                                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                            transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="fecha" outlined readonly
                                                    :rules="[rules.required]" v-bind="attrs"
                                                    @blur="date = parseDate(fecha)" dense v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date" locale="es-mx" :min="minfecha"
                                                @input="(menu1 = false, fechaUpdated())"></v-date-picker>
                                        </v-menu>
                                        <label class="typo__label" style="text-align: center;">Hora:</label>
                                        <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                            :nudge-right="40" :return-value.sync="hora" transition="scale-transition"
                                            offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="hora" :rules="[rules.required]" dense readonly
                                                    outlined v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-time-picker v-if="menu3" v-model="hora" format="24hr" full-width
                                                @click:minute="($refs.menu3.save(hora), fechaUpdated())"
                                                :min="minTime"></v-time-picker>
                                        </v-menu>
                                        <p v-if="oldDateSpan == true" style="color: red;">No se puede poner una
                                            fecha
                                            pasada como fecha de
                                            recordatorio</p>
                                    </template>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" @click="Guardar()">Guardar</v-btn>
                        <v-btn color="error" @click="Cerrar()">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import moment from "moment";
import { MasonryInfiniteGrid } from "@egjs/vue-infinitegrid";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        MasonryInfiniteGrid,
    },
    data: function () {
        return {
            valid: false,
            showcargando: true,
            dialog: false,
            datos: {},
            Notas: [],
            nottitulo: null,
            notdescripcion: null,
            nottipo: '',
            notfechaenvio: '',
            notclave: '',
            oldDateSpan: false,

            minTime: "",
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 250) {
                            return 'Máximo 250 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            menu1: false,
            date: moment().format("YYYY[-]MM[-]DD"),
            fecha: '',
            minfecha: moment().format("YYYY[-]MM[-]DD"),
            rules: {
                required: value => !!value || 'Campo requerido',
                counter: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length >= 5 || 'Minino 5 caracteres'
                    }
                },
                text: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length <= 100 || 'Máximo 100 caracteres'
                    }
                },
            },
            menu3: false,
            hora: '',
            user: '',
            titulo: '',
            disabled: false,
            items: [],
            currentMaxBlogsOnScreen: [],
            TotalNotas: 0,
            ///
            permisoNotas: false
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        date(val) {
            this.fecha = this.formatDate(this.date);
        },
        'nottipo': function (val) {
            this.menu1 = false;
            this.menu3 = false;
        }
    },
    methods: {
        validaestilo(index) {
            if (this.TotalNotas.result == 2 && index == 1) {
                return 'item-style2';
            }
            else
                return '';
        },
        async getInitialItems(nextGroupKey, count, filter) {
            this.items = [];
            this.items = await this.getItems(nextGroupKey, count, filter);
        },

        async getItems(nextGroupKey, count, filter) {
            this.loadingNewPost = true;
            let nextItems = [];
            let cont = 0;
            await this.currentMaxBlogsOnScreen.forEach((element) => {
                const nextKey = nextGroupKey * count + cont;
                nextItems.push({ ...element, groupKey: nextGroupKey, key: nextKey });
                cont = cont + 1;
            });
            return nextItems;
        },

        Cerrar() {
            this.$refs.form.reset();
            this.dialog = false;
        },

        async fechaUpdated() {
            let recordatorioDate = this.date;
            var result = await MetodosGenerales.obtenerFechaHoraBase();

            let today = result.today;
            if (recordatorioDate <= today) {
                this.minTime = result.hora.toString();
            } else {
                this.minTime = '00:00';
            }
            this.oldDateSpan = false;
        },

        async Guardar() {

            if (this.nottipo == true) {
                let res = await MetodosGenerales.obtenerFechaHoraBase();
                let today = res.today;

                let recordatorioDate = this.date;
                if (recordatorioDate <= today) {
                    let tdayFormatted = new Date(today).getTime();
                    let recday = new Date(this.date).getTime();
                    let tdayHora = res.hora;

                    if (recday <= tdayFormatted) {
                        if (this.hora <= tdayHora) {
                            this.oldDateSpan = true;
                        }
                    }
                }
            } else {
                this.oldDateSpan = false;
            }

            if (this.$refs.form.validate() && !this.oldDateSpan) {
                let formdata = new FormData();

                formdata.append("nottitulo", this.nottitulo);
                formdata.append("notdescripcion", this.notdescripcion);
                formdata.append("nottipo", this.nottipo);

                if (this.nottipo == true) {
                    let d = this.date + 'T' + this.hora + ':00';
                    let c = moment(d);
                    formdata.append("notfechaenvio", c.format('YYYY[-]MM[-]DD HH:mm'));
                }
                else {
                    formdata.append("notfechaenvio", null);
                }

                this.$swal({
                    position: 'center',
                    title: 'Guardando Nota...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                if (this.notclave != '') {

                    formdata.append("notclave", this.notclave);
                    await General.EditarNota(formdata).then(data => {
                        if (data.success == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "La nota se modificó correctamente",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {
                                this.Recargar();
                                this.dialog = false;
                                this.valid = false;
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {

                            });
                        }
                    });
                }
                else {
                    formdata.append("uslogin", this.user);
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    await General.NuevaNota(formdata).then(data => {
                        if (data.success == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "La nota se guardó correctamente",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {
                                this.Recargar();
                                this.dialog = false;
                                this.valid = false;
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {

                            });
                        }
                    });
                }
            }
        },
        async nuevo() {
            if (this.nottitulo != null)
                this.$refs.form.reset();
            this.titulo = 'Nueva Nota';
            this.notclave = '';
            this.dialog = true;
            this.nottitulo = null;
            this.notdescripcion = null;
            this.nottipo = false;
            this.date = moment().format("YYYY[-]MM[-]DD");
            this.fecha = this.formatDate(this.date);
            this.hora = null;
            this.valid = true;

            this.oldDateSpan = false;
            this.minTime = moment().format("HH:mm");
        },
        async editar(item) {
            this.titulo = 'Editar Nota';
            this.dialog = true;
            this.notclave = item.notclave;
            this.nottitulo = item.nottitulo;
            this.notdescripcion = item.notdescripcion;
            this.nottipo = item.nottipo;
            this.oldDateSpan = false;

            if (item.nottipo) {
                this.date = item.notfechaenvio != null ? item.notfechaenvio.substring(0, 10) : '';
                this.fecha = this.formatDate(this.date);

                this.hora = item.hora.substring(0, 5);

                let recordatorioDate = new Date(item.notfechaenvio).getTime();
                let today = new Date().getTime();

                if (recordatorioDate < today) {
                    this.oldDateSpan = true;
                }

                if (recordatorioDate <= today) {
                    this.minTime = moment().format("HH:mm");
                }
            }
            else {
                this.date = moment().format("YYYY[-]MM[-]DD");
                this.fecha = this.formatDate(this.date);
                this.hora = '';
            }

        },
        async eliminar(notclave) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar la nota?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    let formdata = new FormData();
                    formdata.append("notclave", notclave);
                    this.$swal.showLoading();
                    General.EliminarNota(formdata).then(data => {
                        if (data.success == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "La nota se eliminó correctamente",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {
                                this.Recargar();
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {

                            });
                        }
                    });
                }
            });
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        async Recargar() {
            let formdata = new FormData();
            formdata.append("nrreporte", this.datos.nrreporte);
            formdata.append("svindice", this.datos.svindice);
            formdata.append("uslogin", this.user);
            this.TotalNotas = await General.TotalNotas(formdata);
            await General.ObtenerNotas(formdata).then(data => {
                if (data.success == true)
                    this.currentMaxBlogsOnScreen = data.result;
            });
            await this.getInitialItems(1, this.currentMaxBlogsOnScreen.length, null);
        }
    },
    async mounted() {

        this.user = MetodosGenerales.ObtenerUserName();
        this.fecha = this.formatDate(this.date);

        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");

        let formdata = new FormData();
        formdata.append("nrreporte", this.datos.nrreporte);
        formdata.append("svindice", this.datos.svindice);
        formdata.append("uslogin", this.user);
        this.TotalNotas = await General.TotalNotas(formdata);

        let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '393');
        if (response.data.length > 0) {
            response.data.forEach(permiso => {
                if (permiso.peclave == 393)//Permiso agregar nota
                    this.permisoNotas = true;
            });
        }
        await MetodosGenerales.getReporteEstatus(this).then(data => {
            if (data == 2)
                this.disabled = true;
            if (this.permisoNotas) {
                this.disabled = false;
            }
        });
        await this.Recargar();
        await this.getInitialItems(0, this.TotalNotas.result, null);
        this.showcargando = false;
    }
}
</script>
<style scoped>
.main-buttons-container::-webkit-scrollbar {
    height: 0.4em;
    border-radius: 50%;
}

.main-buttons-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(165, 165, 165, 0.3);
}

.main-buttons-container::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
    outline: 1px solid rgb(177, 177, 177);
}

/* TODO: THIS SHOULD BE RESPONSIVE */
.item-style {
    min-width: 100%;
    width: 34.5%;
    max-width: 100%;
    padding: 10px 10px 10px 10px;
}

.item-style2 {
    position: absolute;
    top: 0px;
    /*left: 34% !important;*/
}

@media screen and (min-width: 900px) {
    .item-style {
        min-width: 49%;
        width: 32.5%;
        max-width: 100%;
        padding: 10px 10px 10px 10px;
    }

    .item-style2 {
        position: absolute;
        top: 0px;
        left: 50% !important;
    }
}

@media screen and (min-width: 1530px) {
    .item-style {
        min-width: 32.5%;
        width: 32.5%;
        max-width: 100%;
        padding: 10px 10px 10px 10px;
    }

    .item-style2 {
        position: absolute;
        top: 0px;
        left: 34% !important;
    }
}
</style>